import React, { useState } from "react";

import {
    Alert,
    Button,
    Form,
    Input
} from "antd";

import {
    SendOutlined
} from "@ant-design/icons";

const { TextArea } = Input;

const MessageReplyBox = ({
                             inquiryId,
                             loading,
                             canReply,
                             onSendMessage
                         }) => {

    const [message, setMessage] = useState("");

    const handleSend = () => {

        if (!message.trim()) {
            return;
        }

        onSendMessage({
            inquiryId,
            message: message.trim()
        });

        setMessage("");
    };

    return (

        <div
            style={{
                padding:20,
                background:"#fff"
            }}
        >

            {

                !canReply &&

                <Alert

                    showIcon

                    type="warning"

                    message="Vous avez atteint votre limite de 3 messages."

                    style={{
                        marginBottom:20
                    }}

                />

            }

            <Form layout="vertical">

                <Form.Item label="Votre message">

                    <TextArea

                        rows={3}

                        value={message}

                        disabled={!canReply || loading}

                        onChange={

                            e =>

                                setMessage(e.target.value)

                        }

                    />

                </Form.Item>

                <Button

                    type="primary"

                    block

                    icon={<SendOutlined />}

                    disabled={

                        !canReply ||

                        loading ||

                        !message.trim()

                    }

                    onClick={handleSend}

                >

                    Envoyer

                </Button>

            </Form>

        </div>

    );

};

export default MessageReplyBox;